<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Metas, pedido y ventas por vendedor
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Cumplimiento de las metas pedidos y ventas del mes por vendedor
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <mdb-input v-model="fechaMes" type="month" label="Mes" class="my-2" outline />
        </div>
        <!-- Fecha Desde -->
        <div class="col-12 col-md-4">
          <mdb-input class="my-2" v-model="fechaDel" type="date" label="Desde" outline
            @input="$emit('desdeAFiltrar', fechaDel);" />
        </div>
        <!-- Fecha Hasta -->
        <div class="col-12 col-md-4">
          <mdb-input class="my-2" v-model="fechaHasta" type="date" label="Hasta" outline
            @input="$emit('hastaAFiltrar', fechaHasta);" />
        </div>
        <!-- <div class="col-12 col-md-6 col-xl-3 px-0">
          <FiltrosTipo1 :ven="vendedores" :responsive="responsive" :restablecer-filtrado="restablecer"
            :mostrar-btn-restablecer="false" @vendedorAFiltrar="vendedoresFiltrados = $event; actualizar()" />
        </div> -->
      </div>
    </div>
    <div v-if="fechaHasta.length && fechaDel.length" class="col-12 col-md text-center">
      <mdb-btn flat dark-waves icon="broom" class="my-2 px-1" @click="restablecerFiltros()">
        Restablecer filtros
      </mdb-btn>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <!-- Mensaje cuando el vendedor seleccionado no tiene pedido -->
    <div v-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay reportes según los parámetros seleccionados</p>
    </div>
    <div class="container" v-else>
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>
                <div class="ancho-3">
                  SKU
                </div>
              </th>
              <th>
                <div>
                  Meta Kg
                </div>
              </th>
              <th>
                <div>
                  Pedidos kg
                </div>
              </th>
              <th>
                <div>
                  Ventas Kg
                </div>
              </th>
             <th>
                <div>
                  % De cumplimiento <br> de la meta <br>
                  Vs lo pedido
                </div>
              </th>
              <th>
                <div>
                  % De cumplimiento <br> de lo pedido <br>
                  Vs las ventas
                </div>
              </th>
              <th>
                <div>
                  % De cumplimiento <br> de las metas <br>
                  Vs las ventas
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-for="(p, i) in data" :key="i">
                <td data-columna="SKU">
                  <div>
                    <p class="">
                      {{ p.vendedor }}
                    </p>
                  </div>
                </td>
                <td data-columna="Meta Kg">
                  <div class="">
                    <p>{{ p.meta_kg.toFixed(2) }}</p>
                  </div>
                </td>
                <td data-columna="Pedidos Kg">
                  <div class="">
                    <p>{{ p.pedidos_kg.toFixed(2) }}</p>
                  </div>
                </td>
                <td data-columna="Ventas Kg">
                  <div class="">
                    <p>{{ p.ventas_kg.toFixed(2) }}</p>
                  </div>
                </td>
                <td data-columna="% De cumplimiento de la Meta Vs lo pedido">
                  <p>
                    {{ p.cumplimiento_meta_vs_pedido }} %
                  </p>
                </td>
                <td data-columna="% De cumplimiento de lo Pedido Vs las ventas">
                  <div class="">
                    <p>{{ p.cumplimiento_pedido_vs_ventas }} %</p>
                  </div>
                </td>
                <td data-columna="% De cumplimiento de la Meta Vs las ventas">
                  <p>
                    {{ p.cumplimiento_meta_vs_ventas }} %
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from 'mdbvue'
// import FiltrosTipo1 from '@/components/FiltrosTipo1.vue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'
import { apiPost } from '@/funciones/api.js'
import { convertirNumeroAFixed } from '@/funciones/funciones.js'
export default {
  name: 'Actividades',
  components: {
    mdbInput,
    mdbBtn,
    // FiltrosTipo1,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      cargando: false,
      responsive: { vendedor: 'col-12', btnRestablecer: 'col-12 col-md-auto' },
      vendedores: [],
      vendedoresFiltrados: [],
      vendedoresSeleccionados: [],
      fechaMes: (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString(),
      fechaDel: '',
      fechaHasta: '',
      alertaMensaje: { contenido: '' },
      restablecer: false,
      data: [
        {
          vendedor: 'LARA - JUAN CANELON',
          meta_kg: 7800,
          pedidos_kg: 6151,
          ventas_kg: 3651,
          cumplimiento_meta_vs_pedido: 0.79,
          cumplimiento_pedido_vs_ventas: 0.59,
          cumplimiento_meta_vs_ventas: 0.47
        },
        {
          vendedor: 'MERIDA - DANIEL MENDEZ',
          meta_kg: 11082,
          pedidos_kg: 8898,
          ventas_kg: 6398,
          cumplimiento_meta_vs_pedido: 0.80,
          cumplimiento_pedido_vs_ventas: 0.72,
          cumplimiento_meta_vs_ventas: 0.58
        },
        {
          vendedor: 'TACHIRA - JOSMER MORA',
          meta_kg: 26897,
          pedidos_kg: 21611,
          ventas_kg: 17611,
          cumplimiento_meta_vs_pedido: 0.80,
          cumplimiento_pedido_vs_ventas: 0.81,
          cumplimiento_meta_vs_ventas: 0.65
        },
        {
          vendedor: 'ARAGUA - GENNIS ECHEVERRIA',
          meta_kg: 18681,
          pedidos_kg: 15971,
          ventas_kg: 15971,
          cumplimiento_meta_vs_pedido: 0.85,
          cumplimiento_pedido_vs_ventas: 1.00,
          cumplimiento_meta_vs_ventas: 0.85
        },
        {
          vendedor: 'CARABOBO - RAFAEL USEA',
          meta_kg: 20416,
          pedidos_kg: 24460,
          ventas_kg: 24460,
          cumplimiento_meta_vs_pedido: 1.20,
          cumplimiento_pedido_vs_ventas: 1.00,
          cumplimiento_meta_vs_ventas: 1.20
        },
        {
          vendedor: 'PORTUGUESA - LUIZ PIMENTEL',
          meta_kg: 1819,
          pedidos_kg: 2605,
          ventas_kg: 1605,
          cumplimiento_meta_vs_pedido: 1.43,
          cumplimiento_pedido_vs_ventas: 0.62,
          cumplimiento_meta_vs_ventas: 0.88
        },
        {
          vendedor: 'BARINAS - LUIZ PIMENTEL',
          meta_kg: 7931,
          pedidos_kg: 9424,
          ventas_kg: 7924,
          cumplimiento_meta_vs_pedido: 1.19,
          cumplimiento_pedido_vs_ventas: 0.84,
          cumplimiento_meta_vs_ventas: 1.00
        },
        {
          vendedor: 'TRUJILLO - HUMBERTO ARAUJO',
          meta_kg: 17023,
          pedidos_kg: 17598,
          ventas_kg: 9011,
          cumplimiento_meta_vs_pedido: 1.03,
          cumplimiento_pedido_vs_ventas: 0.51,
          cumplimiento_meta_vs_ventas: 0.53
        },
        {
          vendedor: 'DISTRITO CAPITAL 1 - CLAUDIO MENDOZA',
          meta_kg: 15988,
          pedidos_kg: 12871,
          ventas_kg: 9871,
          cumplimiento_meta_vs_pedido: 0.81,
          cumplimiento_pedido_vs_ventas: 0.77,
          cumplimiento_meta_vs_ventas: 0.62
        },
        {
          vendedor: 'MARACAIBO - PEDRO ZAPATA',
          meta_kg: 13718,
          pedidos_kg: 18271,
          ventas_kg: 15271,
          cumplimiento_meta_vs_pedido: 1.33,
          cumplimiento_pedido_vs_ventas: 0.84,
          cumplimiento_meta_vs_ventas: 1.11
        }
      ]
    }
  },
  mounted () {
    this.obtenerVendedoresFiltros()
    this.actualizar()
  },
  watch: {
    vendedoresFiltrados () {
      this.vendedoresSeleccionados = []
      this.agruparVendedoresSeleccionados()
    },
    fechaMes () {
      if (this.vendedoresFiltrados) {
        this.actualizar()
      }
    },
    fechaHasta () {
      if (!this.fechaHasta) return
      this.actualizar()
    },
    fechaDel () {
      if (!this.fechaHasta) return
      this.actualizar()
    }
  },
  methods: {
    agruparVendedoresSeleccionados () {
      this.vendedoresFiltrados.forEach(IdVende => {
        this.vendedores.forEach(vendefiltrado => {
          return vendefiltrado.id_per === IdVende ? this.vendedoresSeleccionados.push(vendefiltrado) : null
        })
      })
    },
    obtenerVendedoresFiltros () {
      apiPost({ s: 'vendedores' }, '')
        .then((res) => {
          this.vendedores = res.data.ven
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los vendedores',
            tipo: 'error'
          }
        })
    },
    restablecerFiltros () {
      this.restablecer = true
      this.vendedoresFiltrados = []
      this.vendedoresSeleccionados = []
      this.fechaMes = (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString()
      this.fechaDel = ''
      this.fechaHasta = ''
      this.actualizar()
    },
    actualizar () {
      console.log('actualizar')
    },
    convertirValorAFixed (numero) {
      return convertirNumeroAFixed(numero)
    },
    mesDelAño () {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses[parseInt(this.fechaMes.split('-')[1], 10) - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: 10px 12px;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: 14px 15px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .75rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

// tr:nth-child(even) {
//   background-color: #f8f9fa;
// }

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}
</style>
